import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import styles from "./activateAccount.module.scss";
import Button from "src/components/button";
import { useDispatch } from "react-redux";
import { userActivation, validateRegistration } from "src/redux/actions/users";
import { useSelector } from "react-redux";
import _ from "lodash";
import cx from "classnames"; 

function ActivateAccount() {
  const dispatch = useDispatch();

  const { id } = useParams() as { id: string };
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const key = searchParams.get("key") as string;
  const [showPasswordText, setShowPasswordText] = React.useState(false);
  const [showConfirmPasswordText, setShowConfirmPasswordText] = React.useState(false);

  useEffect(() => {
    dispatch(validateRegistration({ id: id, activationKey: key }));
  }, []);

  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    password: "",
    confirmPassword: "",
    phoneNumber: "",
  });

  const [error, setError] = useState({
    firstName: "",
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);

  const validationError = useSelector((state) =>
    _.get(state, "users.validate.error"),
  ) as any;

  const validationLoading = useSelector((state) =>
    _.get(state, "users.validate.loading"),
  );

  const activated = useSelector((state) =>
    _.get(state, "users.activation.success"),
  );

  useEffect(() => {
    if (activated) {
      window.location.href = "/activate/success";
    }
  }, [activated]);
  const handleChange = (e) => {
    var { name, value } = e.target;
    if(name === "confirmPassword" || name === "password"){
      value = value.trim();
    }
    setUser((prev) => ({ ...prev, [name]: value }));
    if (name in error) {
      setError((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!user.firstName) {
      setError((prev) => ({
        ...prev,
        firstName: "First name cannot be empty",
      }));
      return;
    }
    if (user.password.length < 8) {
      setError((prev) => ({
        ...prev,
        password: "Password should be at least 8 characters",
      }));
      return;
    }
    if (user.password !== user.confirmPassword) {
      setError((prev) => ({
        ...prev,
        confirmPassword: "Passwords do not match",
      }));
      return;
    }
    setError({ firstName: "", password: "", confirmPassword: "" });
    setLoading(true);

    const { phoneNumber, ...userPayload } = user;
    dispatch(
      userActivation({
        id: id,
        activationKey: key,
        user: { ...userPayload, mobilePhone: phoneNumber },
      }),
    );
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      handleSubmit(event);
    }
  };

  return (
    <div className={styles.activationContainer}>
      <img
        src="/images/Paperflite.png"
        alt="Paperflite Logo"
        className={styles.logo}
      />
      {!validationLoading && (
        <>
          <h1 className={styles.title}>
            {validationError ? (
              <>
                Seems like the account is already activated!
                <p className={styles.signIn}>
                  Continue to{" "}
                  <a href="/public/login">
                    <span className={styles.signInText}>sign in</span>
                  </a>
                  ?
                </p>
              </>
            ) : (
              "Activate your account!"
            )}
          </h1>
          {!validationError && (
            <form
              noValidate
              autoComplete="off"
              className={styles.activateForm}
              onSubmit={handleSubmit}
              onKeyDown={handleKeyPress}
            >
              <input
                className={styles.input}
                type="text"
                name="firstName"
                placeholder="First Name"
                value={user.firstName}
                onChange={handleChange}
              />
              {error.firstName && (
                <p className={styles.error}>
                  <i className="paperflite-danger"></i>
                  <label>{error.firstName}</label>
                </p>
              )}
              <input
                className={styles.input}
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={user.lastName}
                onChange={handleChange}
              />
              <div className={styles.passwordInput}>
                <input
                  className={styles.input}
                  type={showPasswordText ? "text" : "password"}
                  name="password"
                  placeholder="Set password"
                  value={user.password}
                  autoComplete="new-password"
                  onChange={handleChange}
                  onPaste={(e) => e.preventDefault()}
                />
                <i
                  onClick={() => setShowPasswordText(!showPasswordText)}
                  className={cx(
                    showPasswordText ? "paperflite-hidden-eye" : "paperflite-eye",
                  )}
                ></i>
              </div>
              {error.password && (
                <p className={styles.error}>
                  <i className="paperflite-danger"></i>
                  <label>{error.password}</label>
                </p>
              )}
              <div className={styles.passwordInput}>
                <input
                  className={styles.input}
                  type={showConfirmPasswordText ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Confirm password"
                  value={user.confirmPassword}
                  autoComplete="new-password"
                  onChange={handleChange}
                  onPaste={(e) => e.preventDefault()}
                />
                <i
                  onClick={() => setShowConfirmPasswordText(!showConfirmPasswordText)}
                  className={cx(
                    showConfirmPasswordText ? "paperflite-hidden-eye" : "paperflite-eye",
                  )}
                ></i>
              </div>
              {error.confirmPassword && (
                <p className={styles.error}>
                  <i className="paperflite-danger"></i>
                  <label>{error.confirmPassword}</label>
                </p>
              )}
              <input
                className={styles.input}
                type="tel"
                name="phoneNumber"
                placeholder="Phone number"
                value={user.phoneNumber}
                onChange={handleChange}
              />
              <span onClick={handleSubmit}>
                <Button
                  className={styles.button}
                  variant="primary"
                  icon="paperflite-right-arrow"
                  disabled={loading}
                >
                  {loading
                    ? "Activating your account"
                    : "Activate your account"}
                </Button>
              </span>
            </form>
          )}
        </>
      )}
      {validationLoading && <p className={styles.loading}>Loading...</p>}
    </div>
  );
}

export default ActivateAccount;
